import { connect } from 'react-redux'
import { OnboardingAgencyDetailsForm } from '../../components'
import { chatbotEvents, getAgencyDetailsInitialValues } from 'modules/ui/ChatBot'

const mapStateToProps = (state: any) => ({
  initialValues: getAgencyDetailsInitialValues(state),
})

const mapDispatchToProps = (dispatch: any) => {
  return {
    handleSubmit: (values: any) => dispatch(chatbotEvents.agencyDetailsSubmitted(values)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingAgencyDetailsForm)
